import styled, {css} from "styled-components";
import {
    ConstBreakPoint,
    ConstColor,
    ConstWidth,
    ConstZIndex
} from "../../../../config/styles_const/styles_const";
import {NavLink} from "react-router-dom";
import BtnLinkBorderSmall from "../../atom/btn/btn_link_border_small";
import MenuParagraph from "../../atom/text/menu_paragraph";

export const UserMenuWrapper = styled.div`
    padding-top: 15px;
    padding-bottom: 20px;
    width: ${ConstWidth.MenuWidth};
    background-color: ${ConstColor.DeepBlack};
    height: 100%;
    overflow: auto;
    @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
        position: sticky;
        top: 0;
        height: 100vh;
        z-index: ${ConstZIndex.menu};
    }
`;

export const FlexWrapper = styled.div`
    min-height: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
`;

export const MainContentWrapper = styled.div`
    margin-bottom: 50px;
`;

export const LinkWrapper = styled.div`
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${ConstColor.White};
`;

export const ParentLinkWrapper = styled(LinkWrapper)<{isOpen?: boolean}>`
    background-color: inherit;
    color: ${ConstColor.White};
`;

export const LinkText = styled(MenuParagraph)`
    color: inherit;
`;

export const IconText = styled(MenuParagraph)`
    color: inherit;
    font-size: 12px;
    :before {
        margin-right: 0;
    }  
`;

export const ChildOpenBtn = styled.div<{isOpen: boolean}>`
    background-color: ${ConstColor.LightBlack};
    height: 60px;
    width: 60px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${ConstColor.Gray};
    :hover {
        cursor: pointer;
    }
`;

export const ChildrenWrapper = styled.div<{isOpen: boolean}>`
    background-color: ${ConstColor.LightBlack};
    ${props => props.isOpen && css`
        & ${ChildLinkWrapper} {
            height: 50px;
            opacity: 1;
        }
    `}
`;

export const ChildLinkWrapper = styled(LinkWrapper)`
    height: 0;
    opacity: 0;
    transition: all .4s ease;
`;

export const LogoutBtnWrapper = styled.div`
    text-align: center;
`;

export const LogoutBtn = styled(BtnLinkBorderSmall)`
    border-color: ${ConstColor.White};
    background: inherit;
    color: ${ConstColor.White};
`;

export const StyleLink = styled(NavLink)`
    color: inherit;
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    padding-left: 15px;
    // hover 時左に5pxボーダー
    border-left: 5px solid ${ConstColor.DeepBlack};
    &&:hover {
        border-left: 5px solid ${ConstColor.Current};
    }
     
    ${ChildLinkWrapper} > & {
        border-left: 5px solid ${ConstColor.LightBlack};
        padding-left: 40px;
    }
    
    &.active {
        background: ${ConstColor.Current};
        border-left: 5px solid ${ConstColor.Current};
    }
    &.active + ${ChildOpenBtn} {
        background: ${ConstColor.CurrentDeep};
        color: ${ConstColor.Base};
    }

    &.active span {
        color: ${ConstColor.White};
        border-color: ${ConstColor.White};
    }
`;

export const NotLinkMenu = styled.div`
    color: inherit;
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    padding-left: 15px;
    border-left: 5px solid ${ConstColor.DeepBlack};
`;

export const MenuBadgeWrapper = styled.div`
    margin-left: auto;
    margin-right: 52px;
`



// WEBPACK FOOTER //
// ./src/presentation/common/organism/menu/menu_share_components.tsx